<template>
  <div class="hello">
    <div class="content" v-html="news.content"></div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      news: {},
    }

  },

  methods: {
    getInfo(id) {
      if(id===null||id === undefined){
        document.title = '门窗之家'
        this.news.content = "<p>欢迎来到门窗之家展示系统</p>"
        return
      }
      axios({
        url: '/newsInfo/count/'+id,
        method: 'get',
      }
      ).then((respone) => {
        console.log(respone);
        this.news = respone.data.data;
        document.title = this.news.title;
      })
    },
    getQueryVariable(name) {
      // 未传参，返回空
      if (!name) return null;
      // 查询参数：先通过search取值，如果取不到就通过hash来取
      var after = window.location.search;
      after = after.substr(1) || window.location.hash.split("?")[1];
      // 地址栏URL没有查询参数，返回空
      if (!after) return null;
      // 如果查询参数中没有"name"，返回空
      if (after.indexOf(name) === -1) return null;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      // 当地址栏参数存在中文时，需要解码，不然会乱码
      var r = decodeURI(after).match(reg);
      // 如果url中"name"没有值，返回空
      if (!r) return null;
      return r[2];

    },
  },
  created() {
    console.log(this.getQueryVariable("id"));
    this.getInfo(this.getQueryVariable("id"));
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content ::v-deep img {
  width: 100%;
}

.content ::v-deep video {
  width: 100%;
}
.provide{
  color: #5E5E5E;
  text-align: right;
  bottom: 30px;
  right: 30px;
  position: fixed;
}
</style>
